import { useCallback, useState } from 'react';

export const UPCOMING_VISIBILITY_STORAGE_KEY = 'dpPortal.requests.showUpcoming';

function readStoredVisibility(): boolean {
    try {
        return window.localStorage.getItem(UPCOMING_VISIBILITY_STORAGE_KEY) === 'true';
    } catch {
        return false;
    }
}

function writeStoredVisibility(value: boolean): void {
    try {
        window.localStorage.setItem(UPCOMING_VISIBILITY_STORAGE_KEY, String(value));
    } catch {
        return;
    }
}

export function useUpcomingRequestsVisibility() {
    const [showUpcoming, setShowUpcoming] = useState<boolean>(readStoredVisibility);

    const toggle = useCallback(() => {
        setShowUpcoming((current) => {
            const next = !current;
            writeStoredVisibility(next);
            return next;
        });
    }, []);

    return { showUpcoming, toggle };
}
